/**
 * 项目默认配置项
 *
 */

export default {
  http: {
    serverUrl: "",
    responseBody: {
      //http请求响应体
      code: "Code",
      data: "Data",
      message: "Message",
    },
    successCode: 0, //成功的code值
  },
  permission: {
    router: false, //是否开启路由权限验证
    action: true, //是否开启功能权限验证
  },
};
